import { render } from "./AnalyticsPracticeStreak.vue?vue&type=template&id=1af2d8a9&scoped=true"
import script from "./AnalyticsPracticeStreak.vue?vue&type=script&lang=js"
export * from "./AnalyticsPracticeStreak.vue?vue&type=script&lang=js"

import "@/css/components/analytics-practice-streak.css?vue&type=style&index=0&id=1af2d8a9&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1af2d8a9"]])

export default __exports__